export default {
  bind(el, binding) {
    el.clickOutsideEvent = function(event) {
      // Verifica se o clique foi fora do elemento
      if (!(el == event.target || el.contains(event.target))) {
        // Chama a expressão fornecida no binding
        binding.value(event);
      }
    };
    // Adiciona o event listener ao documento
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    // Remove o event listener do documento
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};